<template>
  <ion-page ref="pageRef">
    <ion-content>
      <ion-progress-bar v-show="isSettingsLoading" class="progress-bar" color="medium" type="indeterminate" />

      <app-grid fixed>
        <app-row class="ion-align-items-center">
          <app-col size="12">
            <login-form :page-ref="pageRef" @loading-settings="isSettingsLoading = $event" />
          </app-col>
        </app-row>
      </app-grid>
    </ion-content>
  </ion-page>
</template>

<script lang="ts" setup>
import { IonContent, IonPage, IonProgressBar } from '@ionic/vue';
import type { ComponentPublicInstance } from 'vue';
import { ref } from 'vue';

import { AppGrid, AppRow, AppCol, LoginForm } from '@/components';

const isSettingsLoading = ref<boolean>(false);
const pageRef = ref<ComponentPublicInstance | null>(null);
</script>

<style scoped lang="scss">
.app-grid {
  height: 100%;

  &.grid-fixed {
    --ion-grid-padding: 0;
    max-width: app-bp(md);
  }

  .app-col {
    --ion-grid-column-padding: 0;
  }

  .app-row {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.progress-bar {
  position: fixed;
  top: 0;
  z-index: 1;
}
</style>
